import { TEnrichmentsSelection } from '@/features/segments/types';
import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';

import { usePatchRelaunchBroadcast } from '../api/patch-broadcast-relaunch';
import { TProgramBroadcast } from '../types';

export function useRelaunchBroadcastController() {
  const relaunchBroadcastDrawer = useDisclosureWithData<TProgramBroadcast>();
  const { mutate: relaunchBroadcast, isPending: isRelauchingBroadcast } = usePatchRelaunchBroadcast(
    {
      config: {
        onSuccess: () => {
          relaunchBroadcastDrawer.close();
        },
      },
    }
  );

  const handleRelaunchBroadcast = (id: string, enrichments: TEnrichmentsSelection) => {
    if (!id) return;
    relaunchBroadcast({ id, enrichments });
  };

  return {
    relaunchBroadcastDrawer,
    handleRelaunchBroadcast,
    isRelauchingBroadcast,
  };
}
